module.exports = __webpack_public_path__ + "img/pass.9a454b16.png";